export enum ClientsSortTypes {
  NAME = 'name',
  PROJECTS = 'projects',
  BTWVAT = 'btwVat',
  REVENUE = 'revenue',
}
